<script>
	import { onMount } from 'svelte';
	import { page } from '$app/stores';
	import { updated } from '$app/stores';
	import { authStore } from '$lib/stores/authStore.js';
	import AppLayout from '$lib/components/layout/AppLayout.svelte';
	import PublicLayout from '$lib/components/layout/PublicLayout.svelte';
	import '../app.css';

	export let params;

	let showUpdateBanner = false;

	onMount(() => {
		document.addEventListener('visibilitychange', () => {
			if (!document.hidden && $updated) showUpdateBanner = true;
		});
	});

	$: if ($updated) showUpdateBanner = true;

	$: pathname = $page.url.pathname;
	$: hasError = $page.error;
	$: isPublicPage = pathname === '/' || pathname === '/faq' || pathname.startsWith('/auth');
	$: isNoLayoutPage = pathname.startsWith('/policy') || pathname.startsWith('/consent');

	onMount(() => {
		authStore.init();
	});
</script>

{#if showUpdateBanner}
	<div class="fixed top-0 left-0 right-0 z-[9999] bg-blue-600 text-white text-center py-2 px-4 text-sm shadow-md">
		새 버전이 있습니다.
		<button
			class="ml-2 underline font-semibold hover:text-blue-100"
			on:click={() => location.reload()}
		>
			지금 업데이트
		</button>
	</div>
{/if}

{#if hasError}
	<PublicLayout>
		<slot />
	</PublicLayout>
{:else if isNoLayoutPage}
	<slot />
{:else if isPublicPage}
	<PublicLayout>
		<slot />
	</PublicLayout>
{:else}
	<AppLayout>
		<slot />
	</AppLayout>
{/if}
